import { Libraries } from '@react-google-maps/api';

import { IRegionMapDatasetMapping } from './ExplorerMap.models';

export const REGION_MAP_DATASET_ID_MAPPING: IRegionMapDatasetMapping = {
    SOUTHBRIDGE: { mapId: 'c6edb9b574a7a409', datasetId: '2983bf70-079c-4ba2-a77b-cc02867f7a6f' },
};

export const GOOGLE_MAP_LIBRARIES: Libraries = ['places'];
